"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");
var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/extends"));
var _bind = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/bind"));
var _reduce = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/reduce"));
var _keys = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/object/keys"));
var _filter = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/filter"));
var _react = _interopRequireDefault(require("react"));
var _downshift = _interopRequireDefault(require("downshift"));
// Component was adapted from:
// https://github.com/kentcdodds/downshift-examples/blob/master/src/ordered-examples/04-multi-select.js
// https://codesandbox.io/s/github/kentcdodds/downshift-examples/tree/master/?module=%2Fsrc%2Fordered-examples%2F04-multi-select.js&moduleview=1
class MultiDownshift extends _react.default.Component {
  constructor(props) {
    var _context, _context2, _context3, _context4, _context5;
    super(props);
    // fancy destructuring + defaults + aliases
    // this basically says each value of state should either be set to
    // the initial value or the default value if the initial value is not provided
    const {
      defaultHighlightedIndex,
      initialHighlightedIndex: highlightedIndex = defaultHighlightedIndex,
      defaultIsOpen,
      initialIsOpen: isOpen = defaultIsOpen,
      initialInputValue: inputValue = '',
      initialSelectedItems: selectedItems = []
    } = this.props;
    const state = this.getState({
      highlightedIndex,
      isOpen,
      inputValue,
      selectedItems
    });
    this.state = state;
    this.stateReducer = this.props.stateReducer || this.stateReducer;
    this.removeItem = (0, _bind.default)(_context = this.removeItem).call(_context, this);
    this.addSelectedItem = (0, _bind.default)(_context2 = this.addSelectedItem).call(_context2, this);
    this.getRemoveButtonProps = (0, _bind.default)(_context3 = this.getRemoveButtonProps).call(_context3, this);
    this.getStateAndHelpers = (0, _bind.default)(_context4 = this.getStateAndHelpers).call(_context4, this);
    this.isControlledProp = (0, _bind.default)(_context5 = this.isControlledProp).call(_context5, this);
  }

  /**
   * Gets the state based on internal state or props
   * If a state value is passed via props, then that
   * is the value given, otherwise it's retrieved from
   * stateToMerge
   *
   * This will perform a shallow merge of the given state object
   * with the state coming from props
   * (for the controlled component scenario)
   * This is used in state updater functions so they're referencing
   * the right state regardless of where it comes from.
   *
   * @param {Object} stateToMerge defaults to this.state
   * @return {Object} the state
   */
  getState() {
    var _context6;
    let stateToMerge = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.state;
    return (0, _reduce.default)(_context6 = (0, _keys.default)(stateToMerge)).call(_context6, (state, key) => {
      state[key] = this.isControlledProp(key) ? this.props[key] : stateToMerge[key];
      return state;
    }, {});
  }
  getStateAndHelpers(stateAndHelpers) {
    const {
      selectedItems
    } = this.getState();
    const {
      getRemoveButtonProps,
      removeItem
    } = this;
    return {
      getRemoveButtonProps,
      removeItem,
      selectedItems,
      ...stateAndHelpers
    };
  }
  getRemoveButtonProps() {
    let {
      onClick,
      item,
      disabled,
      ...props
    } = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    return {
      onClick: e => {
        if (!disabled) {
          // TODO: use something like downshift's composeEventHandlers utility instead
          onClick && onClick(e);
          e.stopPropagation();
          this.removeItem(item);
        }
      },
      disabled: disabled,
      ...props
    };
  }

  /**
   * This determines whether a prop is a "controlled prop" meaning it is
   * state which is controlled by the outside of this component rather
   * than within this component.
   * @param {String} key the key to check
   * @return {Boolean} whether it is a controlled controlled prop
   */
  isControlledProp(key) {
    return this.props[key] !== undefined;
  }
  stateReducer(state, changes) {
    switch (changes.type) {
      case _downshift.default.stateChangeTypes.keyDownEnter:
      case _downshift.default.stateChangeTypes.clickItem:
        return {
          ...changes,
          highlightedIndex: state.highlightedIndex,
          isOpen: true,
          inputValue: ''
        };
      // this isn't great, but it's needed to handle the selectItem call
      // in select-input.onKeyDown
      case undefined:
        return {
          ...changes,
          inputValue: ''
        };
      default:
        return changes;
    }
  }
  removeItem(item) {
    const {
      selectedItems
    } = this.getState();
    const newSelectedItems = (0, _filter.default)(selectedItems).call(selectedItems, i => i !== item);
    if (this.props.onChange) {
      this.props.onChange(newSelectedItems, this.getStateAndHelpers());
    }
    if (!this.isControlledProp('selectedItems')) {
      this.setState({
        selectedItems: newSelectedItems
      });
    }
  }
  addSelectedItem(item, stateAndHelpers) {
    const {
      selectedItems
    } = this.getState();
    const newSelectedItems = [...selectedItems, item];
    if (this.props.onChange) {
      this.props.onChange(newSelectedItems, this.getStateAndHelpers(stateAndHelpers));
    }
    if (!this.isControlledProp('selectedItems')) {
      this.setState({
        selectedItems: newSelectedItems
      });
    }
  }
  render() {
    const {
      children,
      ...props
    } = this.props;
    // TODO: compose together props (rather than overwriting them) like downshift does
    return /*#__PURE__*/_react.default.createElement(_downshift.default, (0, _extends2.default)({}, props, {
      stateReducer: this.stateReducer,
      onChange: this.addSelectedItem,
      selectedItem: null
    }), stateAndHelpers => children(this.getStateAndHelpers(stateAndHelpers)));
  }
}
var _default = exports.default = MultiDownshift;
MultiDownshift.__docgenInfo = {
  "description": "",
  "methods": [{
    "name": "getState",
    "docblock": "Gets the state based on internal state or props\nIf a state value is passed via props, then that\nis the value given, otherwise it's retrieved from\nstateToMerge\n\nThis will perform a shallow merge of the given state object\nwith the state coming from props\n(for the controlled component scenario)\nThis is used in state updater functions so they're referencing\nthe right state regardless of where it comes from.\n\n@param {Object} stateToMerge defaults to this.state\n@return {Object} the state",
    "modifiers": [],
    "params": [{
      "name": "stateToMerge",
      "description": "defaults to this.state",
      "type": {
        "name": "Object"
      },
      "optional": false
    }],
    "returns": {
      "description": "the state",
      "type": {
        "name": "Object"
      }
    },
    "description": "Gets the state based on internal state or props\nIf a state value is passed via props, then that\nis the value given, otherwise it's retrieved from\nstateToMerge\n\nThis will perform a shallow merge of the given state object\nwith the state coming from props\n(for the controlled component scenario)\nThis is used in state updater functions so they're referencing\nthe right state regardless of where it comes from."
  }, {
    "name": "getStateAndHelpers",
    "docblock": null,
    "modifiers": [],
    "params": [{
      "name": "stateAndHelpers",
      "type": null
    }],
    "returns": null
  }, {
    "name": "getRemoveButtonProps",
    "docblock": null,
    "modifiers": [],
    "params": [{
      "name": "{ onClick, item, disabled, ...props }",
      "type": null
    }],
    "returns": null
  }, {
    "name": "isControlledProp",
    "docblock": "This determines whether a prop is a \"controlled prop\" meaning it is\nstate which is controlled by the outside of this component rather\nthan within this component.\n@param {String} key the key to check\n@return {Boolean} whether it is a controlled controlled prop",
    "modifiers": [],
    "params": [{
      "name": "key",
      "description": "the key to check",
      "type": {
        "name": "String"
      },
      "optional": false
    }],
    "returns": {
      "description": "whether it is a controlled controlled prop",
      "type": {
        "name": "Boolean"
      }
    },
    "description": "This determines whether a prop is a \"controlled prop\" meaning it is\nstate which is controlled by the outside of this component rather\nthan within this component."
  }, {
    "name": "stateReducer",
    "docblock": null,
    "modifiers": [],
    "params": [{
      "name": "state",
      "type": null
    }, {
      "name": "changes",
      "type": null
    }],
    "returns": null
  }, {
    "name": "removeItem",
    "docblock": null,
    "modifiers": [],
    "params": [{
      "name": "item",
      "type": null
    }],
    "returns": null
  }, {
    "name": "addSelectedItem",
    "docblock": null,
    "modifiers": [],
    "params": [{
      "name": "item",
      "type": null
    }, {
      "name": "stateAndHelpers",
      "type": null
    }],
    "returns": null
  }],
  "displayName": "MultiDownshift"
};